module.exports = require("@splunk/dashboard-visualizations/Pie");